var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.67 18.25",
    style: {
      enableBackground: "new 0 0 21.67 18.25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AFDADB;}\r\n\t.st1{fill:#00386C;}\r\n\t.st2{fill:#2F9BAB;}\r\n\t.st3{fill:#54BDC9;}\r\n\t.st4{opacity:0.13;}\r\n\t.st5{fill:#231F20;}\r\n\t.st6{opacity:0.5;fill:#FFFFFF;}\r\n\t.st7{clip-path:url(#SVGID_00000032630603869042223800000017688136485368562087_);}\r\n\t.st8{fill:none;stroke:#787878;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#00386C;stroke-width:0.84;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.78,15.01h2.63c1.01,0,1.84-0.82,1.84-1.84V7.76c0-1.01-0.82-1.84-1.84-1.84H2.26 c-1.01,0-1.84,0.82-1.84,1.84v5.41c0,1.02,0.82,1.84,1.84,1.84h2.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.78,5.92H4.89V0.59c0-0.09,0.07-0.17,0.17-0.17h11.55c0.09,0,0.17,0.07,0.17,0.17V5.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.51,17.83H5.16c-0.15,0-0.27-0.12-0.27-0.27v-5.09c0-0.15,0.12-0.27,0.27-0.27h11.35 c0.15,0,0.27,0.12,0.27,0.27v5.09C16.78,17.71,16.65,17.83,16.51,17.83z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 6.75,
    y1: 13.99,
    x2: 14.92,
    y2: 13.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 6.75,
    y1: 16.01,
    x2: 14.92,
    y2: 16.01
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.0fa408bdae5494f30611b9b6251a8215.svg";
export { ForwardRef as ReactComponent };